import React, { useMemo, useState } from 'react'
import { Box, Button } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { crossAssociationTreeAtom, subTreeAtom } from './atoms'
import { CurriculaTree } from '../utility/CurriculaTree/CurriculaTree'
import { LanguageSelect } from './components'
import { useCreateCrossAssociationRoot } from './hooks'

export function SubTreeInput() {
  const tree = useAtomValue(crossAssociationTreeAtom)
  const [isDoingInput, setIsDoingInput] = useState(false)
  const subtrees = useAtomValue(subTreeAtom)

  if (subtrees.length > 1) return null

  if (isDoingInput) {
    return (
      <Box>
        <Button onClick={() => setIsDoingInput(false)}>Cancel</Button>
        <GetSubtree />
      </Box>
    )
  }
  return (
    <Box>
      <Button disabled={!tree} onClick={() => setIsDoingInput(true)}>
        Get Subtree
      </Button>
    </Box>
  )
}

function GetSubtree() {
  const [selectedLanguage, setSelectedLanguage] = useState<string>('English')
  const tree = useAtomValue(crossAssociationTreeAtom)
  const createRoot = useCreateCrossAssociationRoot()

  const treeNodeButtons = useMemo(() => {
    const onNodeSelect = ({ id }: { id: string }) => {
      return createRoot({ nodeId: id, language: selectedLanguage })
    }

    return [
      {
        Element: () => <Button>Select</Button>,
        onClick: onNodeSelect,
      },
    ]
  }, [selectedLanguage, createRoot])

  if (!tree) return null

  return (
    <Box>
      <LanguageSelect
        selectedLanguage={selectedLanguage}
        onLanguageSelect={setSelectedLanguage}
      />
      <CurriculaTree tree={tree} nodeButtons={treeNodeButtons} />
    </Box>
  )
}
